import { render } from "./SignItemWrap.vue?vue&type=template&id=4f8c7df2&scoped=true"
import script from "./SignItemWrap.vue?vue&type=script&lang=js"
export * from "./SignItemWrap.vue?vue&type=script&lang=js"

import "./SignItemWrap.vue?vue&type=style&index=0&id=4f8c7df2&lang=stylus"
import "./SignItemWrap.vue?vue&type=style&index=1&id=4f8c7df2&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8c7df2"]])

export default __exports__